
<div *ngIf="texts" class="row justify-content-center">
    <div class="NgxEditor__Wrapper p-20 m-b-40 col-10">
        <ngx-editor-menu [editor]="editor"> </ngx-editor-menu>
        <ngx-editor
        [editor]="editor"
        [(ngModel)]="html"
        [placeholder]="'Escriba su texto...'"
        ></ngx-editor>
        <button class="btn btn-success btn-rounded waves-effect pull-right m-t-20" (click)="update()">Guardar</button>
    </div>
</div>
